import { Box, HStack, Tag, Text, Wrap, WrapItem, Icon } from '@chakra-ui/react';
import { Tooltip } from '@/components/ui/tooltip';
import { FiInfo } from 'react-icons/fi'

interface Opt { value: string; label: string; tip?: string }
interface Props { label: string; tip?: string; options: Opt[]; value: string[]; onChange: (n: string[]) => void }

export function MultiSelectChipRow({ label, tip, options, value, onChange }: Props) {
  const toggle = (v: string) => onChange(value.includes(v) ? value.filter(x => x !== v) : [...value, v])
  return (
    <Box>
      <HStack gap={1} mb={1}>
        <Text fontSize="sm" fontWeight="medium">{label}</Text>
        {tip && <Tooltip content={tip} showArrow><span><Icon color="gray.400" boxSize={3} asChild><FiInfo /></Icon></span></Tooltip>}
      </HStack>
      <Wrap gap={2}>
        {options.map(o => (
          <WrapItem key={o.value}>
            <Tooltip content={o.tip} disabled={!o.tip} showArrow>
              <Tag.Root size="md" borderRadius="full" cursor="pointer"
                variant={value.includes(o.value) ? 'solid' : 'outline'}
                colorPalette={value.includes(o.value) ? 'blue' : 'gray'}
                onClick={() => toggle(o.value)}>{o.label}</Tag.Root>
            </Tooltip>
          </WrapItem>
        ))}
      </Wrap>
    </Box>
  );
}
